const categoriesGradientHeadband = document.querySelector('.gradient-headband .categories');
const categorysGradientHeadband = document.querySelectorAll('.gradient-headband .item');

if(categorysGradientHeadband.length > 0){
    for(let y=0; y<15;y++){
    for(let i=0; i<categorysGradientHeadband.length; i++) {

        const initialItem = categorysGradientHeadband[i];
        const clonedItem = initialItem.cloneNode(true);
        categoriesGradientHeadband.appendChild(clonedItem);

    }
    }
}

// SCROLLING

let transformScrolingGradientHeadband = 0;
const widthMaxScrolling = categoriesGradientHeadband.offsetWidth - window.innerWidth;

function updateTransformScrollingGradientHeadband(){
    if(transformScrolingGradientHeadband<widthMaxScrolling){
    transformScrolingGradientHeadband = transformScrolingGradientHeadband+1;
    }else{
    transformScrolingGradientHeadband = 0;
    }
    categoriesGradientHeadband.style.transform = `translateX(-${transformScrolingGradientHeadband}px)`;
}

const scrollInterval = setInterval(updateTransformScrollingGradientHeadband, 20);